import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { DataExportSchemaConfig, UpdateDataExportSchemaConfigRequest } from '../types';
import { DATA_EXPORT_SCHEMA_CONFIG_KEY } from './useDataExportSchemaConfig';
import { DATA_EXPORT_SCHEMA_CONFIGS_KEY } from './useDataExportSchemaConfigs';

type SaveConfigParams = {
  configId: string;
  config: UpdateDataExportSchemaConfigRequest;
};

export default function useSaveDataExportSchemaConfig() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: ({ configId, config }: SaveConfigParams) =>
      api.put<DataExportSchemaConfig>(`/data-export-configs/${configId}`, config),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: DATA_EXPORT_SCHEMA_CONFIG_KEY,
      });
      queryClient.invalidateQueries({
        queryKey: DATA_EXPORT_SCHEMA_CONFIGS_KEY,
      });
      queryClient.invalidateQueries({
        queryKey: ['data-export-configs', variables.configId],
      });
    },
  });

  const saveConfig = async (configId: string, config: UpdateDataExportSchemaConfigRequest) => {
    await mutateAsync({ configId, config });
  };

  return { saveConfig, isLoading };
}
